import { FieldModel } from '@cibo/core'
import { GridCallbackDetails, GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { useFieldSelectionContext } from './PaginatedFieldsContexts'
import { PaginatedFieldsTable } from './PaginatedFieldsTable'
import { PaginatedFieldsTableProps } from './PrivatePaginatedFieldsTableTypes'

export type SelectableFieldsTableProps = Omit<
  PaginatedFieldsTableProps<FieldModel>,
  'handlePageChange' | 'rowSelectionModel'
>

export const SelectablePaginatedFieldsTable = ({
  onRowSelectionModelChange,
  ...dataGridProProps
}: SelectableFieldsTableProps) => {
  const { selectionModel, setSelectionModel } = useFieldSelectionContext()

  const handleSelectionModelChange = (
    rowSelectionModel: GridRowSelectionModel,
    details: GridCallbackDetails
  ) => {
    !!onRowSelectionModelChange && onRowSelectionModelChange(rowSelectionModel, details)
    setSelectionModel(rowSelectionModel)
  }

  return (
    <PaginatedFieldsTable
      sx={{ borderStyle: 'none' }}
      checkboxSelection
      keepNonExistentRowsSelected
      rowSelectionModel={selectionModel}
      onRowSelectionModelChange={handleSelectionModelChange}
      {...dataGridProProps}
    />
  )
}
